 
<template>
    <div class="mt-4" v-if="users && users.params_calificacion">
        <vs-button
            :disabled="flagDownload"
            class="ml-auto"
            success
            color="#7d33ff"
            @click="descargarActa()"
        >
            <i class="fas fa-download mr-2"></i> Descargar Acta
        </vs-button>
        <div class="sticky-boton py-3">
            <vs-button
                class="ml-auto"
                success
                @click="postGuardarSabana()"
                :disabled="!users.alumnos || botonCali"
            >
                <i class="far fa-save mr-2"></i> Guardar cambios
            </vs-button>
        </div>
        <vs-row class="mb-4">
            <vs-col sm="12" lg="4" class="center content-inputs">
                <form autocomplete="off">
                <label class="labelInput">
                    Número de clases impartidas en el periodo seleccionado
                </label>
                <div class="vs-input-content">
                    <input class="vs-input" v-model="numero_clases_impartidas" type="number" min="0" pattern="[0-9]{10}">
                </div>
                <div style="color:red;" v-if="errorFields.includes('numero_clases_impartidas')">
                    <small>Requerido</small>
                </div>
                </form>
            </vs-col>
        </vs-row>
        <div style="overflow-x: auto " v-dragscroll>
            <table class="table  table-striped vs-table">
                <thead>
                    <tr>
                        <th class="text-center" scope="col" width="25%">Alumno</th>
                        <th class="text-center" scope="col" width="20%">Grupo Administrativo</th>
                        <th class="text-center" scope="col" v-for="(materia, i) in materias" :key="i">{{materia.asignatura}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        :key="i"
                        v-for="(tr, i) in users.alumnos"
                        :data="tr.id"
                    >
                        <td>
                            <vs-row>
                                <vs-col sm="12" lg="2">
                                    <div class="imgAlumno text-center">
                                        <img :src="'/api/personas/' + window.atob(tr.persona_alumno_id) + '/avatar'" alt="">
                                    </div>
                                </vs-col>
                                <vs-col sm="12" lg="10">
                                    <div class="d-flex">
                                        <md-chip style="background: rgb(214, 234, 248); color: #2874A6" class="mb-1 fontMedium mini-chip col-blue">
                                            <p>No. Lista: <strong><span>{{ tr.no_lista }}</span></strong></p>
                                        </md-chip>
                                        <vs-tooltip>
                                            <vs-button
                                                icon
                                                color="success"
                                                flat
                                                @click="modalBoleta(tr)"
                                            >
                                                <i class="far fa-id-card" style="font-size: 0.7rem"></i>
                                            </vs-button>
                                            <template #tooltip>
                                                Ver boleta
                                            </template>
                                        </vs-tooltip>
                                    </div>
                                    <div>
                                        <p class="mb-0"><strong>{{tr.alumno_name}}</strong></p>
                                        <p class="mb-0"><small class="text-uppercase "><i>Matrícula: </i></small><strong>{{tr.alumno_matricula}}</strong></p>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </td>
                        <td class="text-center">
                            <p><strong>{{tr.grupo_administrativo}}</strong></p>
                        </td>
                        <td class="calificacionInput" v-for="(materia, j) in users.alumnos[0].sabana_alumno" :key="j">
                            <div v-if="escala == 'numerica'">
                                <form autocomplete="off">
                                    <input
                                        type="number"
                                        :tabindex="Number(j) + 1"
                                        v-model="calificacion[i][j]"
                                        :disabled="users.params_calificacion.status_captura == false  || tr.status_captura_docente == false"
                                        @input="validarEntero(i,j, materia, 'calificacion'), validateGrade(calificacion[i][j], i, j, materia.escala_calificacion), getFlagDownload()"
                                    />
                                </form>
                                <p v-if="noPermitir[i][j]" style="color: red"><small>El valor debe de estar entre {{materia.escala_calificacion.valor_minimo}} y {{materia.escala_calificacion.valor_maximo}}.</small></p>
                            </div>
                            <div v-if="escala == 'alfanumerica'">
                                <form autocomplete="off">
                                    <vs-select placeholder="Calificación" v-model="alfanumerico[i][j]" @change="getFlagDownloadAlfanumerica()"
                                        :tabindex="Number(i) + 1">
                                        <vs-option v-for="escala in alfanumericoCalif" :key="escala" :label="escala" :value="escala">
                                            {{escala}}
                                        </vs-option>
                                    </vs-select>
                                </form>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <boleta v-model="boletaActive" :parametros="parametros" :persona="persona" :infoRow="infoRow" :nivel="nivel" :personaId="persona_id"></boleta>
        
        <descarga-acta-calificaciones-sabana :parametros="parametros" :users="users" :hoy="hoy" :fechaModificacion="fechaModificacion" :materias="materias" ref="actaCalificacionesSabana"></descarga-acta-calificaciones-sabana>
    </div>
</template>
<script>
import evaluaciones from '../../api/requests/docente/evaluaciones.js'
import boleta from './boleta.vue'
import { dragscroll } from 'vue-dragscroll'
import DescargaActaCalificacionesSabana from './actas/acta_calificaciones_sabana.vue'
    export default {
        props:[
            'users',
            'csrf_token',
            'parametros',
            'persona',
            'nivel'
        ],
        data:() => ({
            ruta: '',
            materias: {},
            calificacion: [],
            alfanumerico: [],
            alfanumericoCalif: [],
            faltas: [],
            conducta: [],
            tareas: [],
            observaciones: [],
            noPermitir: [],
            boton: false,
            botonCali: false,
            escala: '',
            persona_id: '',
            boletaActive: false,
            infoRow:[],
            ejecutar: 0,
            fechaModificacion: '',
            hoy: '',
            flagDownload: false,
            calificacionEspejo: [],
            numero_clases_impartidas: '',
            errorFields: []
        }),
        created(){
            const url = window.location.pathname.split('/')
            this.id_alumno = url[3]
            this.ruta = window.location.protocol
            this.host = window.location.host
            const fechaAcutal = new Date()
            const fecha = fechaAcutal.getDate() + '-' + ( fechaAcutal.getMonth() + 1 ) + '-' + fechaAcutal.getFullYear()
            const hora = fechaAcutal.getHours() + ':' + fechaAcutal.getMinutes() + ':' + fechaAcutal.getSeconds()
            this.hoy = fecha + ' ' + hora
            
            // this.getRubros()
            // this.getCalificacion()
            // this.getPermitir()
        },
        components: {
            boleta,
            DescargaActaCalificacionesSabana
        },    
        directives: {
        'dragscroll': dragscroll
        },
        methods:{
            modalBoleta(tr){
                this.persona_id = atob(tr.persona_alumno_id)
                this.infoRow = tr
                this.boletaActive =! this.boletaActive
            },
            descargarActa(){
                this.$refs.actaCalificacionesSabana.getGenerarPDFActas()
            },
            validarEntero(i,j, info, tipo){
                if(info.escala_calificacion.tipo_numerico == 'entero' && tipo == 'calificacion'){
                    const numero = this.calificacion[i][j].replace(/[^\d]/g,'')
                    this.calificacion[i][j] = numero
                }
            },
            getFecha(){
                if(this.users != ''){
                    let fecha = this.users.params_calificacion.fecha_modificacion;
                    const myArr = fecha.split("T");
                    this.fechaModificacion = myArr[0]
                }
            },
            getFlagDownload(){
                let count = 0
                this.calificacionEspejo.forEach((element, x) => {
                    element.forEach((el, y) => {
                        if(el != this.calificacion[x][y]){
                            count ++
                        }
                    })
                })
                this.flagDownload = count > 0 ? true : false
            },
            getFlagDownloadAlfanumerica(){
                let count = 0
                this.calificacionEspejo.forEach((element, x) => {
                    element.forEach((el, y) => {
                        if(el != this.alfanumerico[x][y]){
                            count ++
                        }
                    })
                })
                this.flagDownload = count > 0 ? true : false
            },
            async generateReport () {
                // this.$refs.html2Pdf.generatePdf()
                if(this.flagDownload){
                    console.log("Habilitó manualmente el botón!")
                    return false
                }else{
                    const loading = this.$vs.loading({
                        text: 'No cierre la ventana, se está generando el Acta.'
                    })
                    this.$refs.html2Pdf.generatePdf()
                    
                    loading.close()
                }
            },
            
            openLoading() {
                const loading = this.$vs.loading({
                    target: this.$refs.html2Pdf.generatePdf(),
                })
                setTimeout(() => {
                    loading.close()
                }, 8000)
            },
            validateGrade(valor, i, j, escala){
                if(valor != ''){
                        if(valor > escala.valor_maximo || valor < escala.valor_minimo){
                        this.noPermitir[i][j] = true
                        let array = []
                        this.noPermitir.forEach(x => {
                            array.push(x.includes(true))
                        })
                        this.botonCali = array.includes(true)
                    }else{
                        this.noPermitir[i][j] = false
                        let array = []
                        this.noPermitir.forEach(x => {
                            array.push(x.includes(true))
                        })
                        this.botonCali = array.includes(true)
                    }
                    // if(valor > this.users.alumnos[0].sabana_alumno[0].escala_calificacion.valor_maximo || valor < this.users.alumnos[0].sabana_alumno[0].escala_calificacion.valor_minimo){

                    //     this.noPermitir[i][j] = true
                    //     let array = []
                    //     this.noPermitir.forEach(x => {
                    //         array.push(x.includes(true))
                    //     })
                    //     this.botonCali = array.includes(true)
                    // }else{
                    //     this.noPermitir[i][j] = false
                    //     let array = []
                    //     this.noPermitir.forEach(x => {
                    //         array.push(x.includes(true))
                    //     })
                    //     this.botonCali = array.includes(true)
                    // }
                }else{
                    this.noPermitir[i][j] = false
                        let array = []
                        this.noPermitir.forEach(x => {
                            array.push(x.includes(true))
                        })
                        this.botonCali = array.includes(true)
                }
            },
            setAltImg(event) { 
                event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg" 
            },
            getRubros(){
                if(this.users.params_calificacion){
                    this.materias = this.users.alumnos[0].sabana_alumno
                    this.escala = this.users.alumnos[0].sabana_alumno[0].escala_calificacion.tipo_escala
                    this.alfanumericoCalif = this.users.alumnos[0].sabana_alumno[0].escala_calificacion.valores_alfanumericos
                    if(this.users.params_calificacion.status_captura == true){
                        this.boton = true
                    }else{
                        this.boton = false
                    }
                }
            },
            getCalificacion(){
                if(this.users != ''){
                    let result = []
                    const info = this.users.alumnos
                    info.forEach(i => {
                        let array = []
                        i.sabana_alumno.forEach(element => {
                            if(element.calificacion){
                                array.push(element.calificacion)
                            }else{
                                array.push('')
                            }
                        })
                        result.push(array)
                    })
                    this.calificacion = result
                }
            },
            getCalificacionEspejo(){
                if(this.users != ''){
                    let result = []
                    const info = this.users.alumnos
                    info.forEach(i => {
                        let array = []
                        i.sabana_alumno.forEach(element => {
                            if(element.calificacion){
                                array.push(element.calificacion)
                            }else{
                                array.push('')
                            }
                        })
                        result.push(array)
                    })
                    this.calificacionEspejo = result
                }
            },
            getAlfanumerica(){
                if(this.users != ''){
                    let result = []
                    const info = this.users.alumnos
                    info.forEach(i => {
                        let array = []
                        i.sabana_alumno.forEach(element => {
                            if(element.calificacion){
                                array.push(element.calificacion)
                            }else{
                                array.push('')
                            }
                        })
                        result.push(array)
                    })
                    this.alfanumerico = result
                }
            },
            getAlfanumericaEspejo(){
                if(this.users != ''){
                    let result = []
                    const info = this.users.alumnos
                    info.forEach(i => {
                        let array = []
                        i.sabana_alumno.forEach(element => {
                            if(element.calificacion){
                                array.push(element.calificacion)
                            }else{
                                array.push('')
                            }
                        })
                        result.push(array)
                    })
                    this.calificacionEspejo = result
                }
            },
            getPermitir(){
                if(this.users != ''){
                    let result = []
                    const info = this.users.alumnos
                    info.forEach(i => {
                        let array = []
                        i.sabana_alumno.forEach(element => {
                            array.push(false)
                        })
                        result.push(array)
                    })
                    this.noPermitir = result
                }
            },
            async postGuardarSabana(){
                if (!this.numero_clases_impartidas) {
                    this.errorFields.push('numero_clases_impartidas')
                    return false
                }
                const loading = this.$vs.loading()
                const alumnos = this.users.alumnos
                const infoAlum = []
                const info = {}
                for( var i = 0; i < alumnos.length; i++ ){
                    const sabana_alumno = alumnos[i].sabana_alumno
                    let registro_academico = alumnos[i].registro_academico_id
                    const calif = [] 
                    for( var j = 0; j < sabana_alumno.length; j++ ){
                        let objCalif = {
                            codigo_sesion_id: sabana_alumno[j].codigo_sesion_id,
                            calificacion_id: sabana_alumno[j].calificacion_id,
                            aplica_para_alumno: sabana_alumno[j].aplica_para_alumno
                        }
                        if(this.users.alumnos[0].sabana_alumno[0].escala_calificacion.tipo_escala == 'alfanumerica'){
                                objCalif.calificacion = this.alfanumerico[i][j]
                        }else if(this.users.alumnos[0].sabana_alumno[0].escala_calificacion.tipo_escala == 'numerica'){
                                objCalif.calificacion = this.calificacion[i][j]
                        }
                        calif.push(objCalif)
                    }
                    const alumno = {
                            registro_academico_id : registro_academico,
                            calificaciones: calif
                        }
                    infoAlum.push(alumno)
                }
                info.alumnos = infoAlum
                info._token = this.csrf_token,
                info.ciclo_escolar_id = this.users.params_calificacion.configuracion_evaluacion.ciclo_escolar_id,
                info.configuracion_evaluacion_id = this.users.params_calificacion.configuracion_evaluacion.id,
                info.institucion_id = this.users.params_calificacion.configuracion_evaluacion.institucion_id
                info.clases_impartidas = this.numero_clases_impartidas
                const payload = Object.assign(info)
                try {
                    const { data: response } = await evaluaciones.postGuardarSabana(payload)
                    loading.close()
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'La evaluación se guardo correctamente.'
                    })
                    this.flagDownload = false
                }
                catch{
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: 'Hubo un error, favor de contactar al administrador.'
                    })
                }
            },
        },
        watch:{
            users(){
                this.getRubros()
                this.getFecha()
                this.getCalificacion()
                this.getCalificacionEspejo()
                this.getAlfanumerica()
                this.getAlfanumericaEspejo()
                this.getPermitir()
                this.numero_clases_impartidas = this.users.clases_impartidas
                this.flagDownload = false
            }
        }
    }
</script>
 
<style lang="scss" scoped>
    .imgAlumno{
        border-radius: 20%;
    }
 
    .imgAlumno img{
        width:80%;
        margin-left: 3%;
        border-radius: 10px;
    }
 
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
 
    .tablePDF{
        width: 100%;
        thead{
            border-bottom: 1px solid gray;
        }
 
        tbody tr{
            border-bottom: 1px solid rgb(207, 207, 207);
        }
        tbody tr td{
            padding: 1px;
        }
        .centrarTexto{
            text-align: center;
        }
 
    }
</style>
 
<style>
.sticky-boton {
    position: sticky;
    position: -webkit-sticky;
    top: 3px;
    background: white;
    z-index: 999;
}
 
.sticky-header {
    position: sticky;
    position: -webkit-sticky;
    top: 75px;
    background: #f4f7f8;
    z-index: 999;
}
 
 
.table-striped tbody tr:nth-of-type(odd){
    background-color: #f9fcfd !important;
    color: #2C3E50;
}
.pdfLetra{
    font-size: 10.5px;
}
</style>
 
        

